import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react"
import { FormGroup, InputGroup, InputGroupText, Input, Button } from "reactstrap";

function PasswordInput(props:any) {
	const {
		id,
		name,
		value,
		placeholder,
		className,
		validate = (value: string) => !(value && value.length),
		onChange,
		...rest
	}: {
		id: any,
		name: string,
		value: string,
		placeholder:string,
		className: any,
		validate?: Function,
		onChange: Function,
		} = props

	const [type, setType] = useState<'text' | 'password'>('password');
	let passwordInput: any;

	const showHide = (e: any) => {
		e.preventDefault();
		e.stopPropagation();
		setType((prevType) => prevType === 'text' ? 'password' : 'text');
	}

	const handleChange = (e: any) => {
		const value = e.target.value;
		const error = validate(value);
		return onChange({ target: { name, value }}, error)
	}

	return (
		<FormGroup>
			<InputGroup>
				<InputGroupText
					style={{
						border: "1px solid #ced4da",
						borderRadius: ".25rem",
						borderRight: "none",
						marginRight: "-4px",
						padding: '0px',
						backgroundColor: 'transparent'
					}}
				>
					<span
						color="default"
						style={{
							cursor: "inherit",
							margin: "auto"
						}}
						className="btn btn-default btn-sm bg-transparent"
					>
						<FontAwesomeIcon icon="key" />
					</span>
				</InputGroupText>
				<Input
					type={type}
					ref={input => passwordInput = input}
					id={id}
					name={name}
					placeholder={placeholder}
					autoComplete="off"
					value={value}
					style={{
						...props.inputStyles
					}}
					className="py-2 border-left-0 border-right-0 border"
					onChange={handleChange}
					{...rest}
				/>
				<InputGroupText
					style={{
						border: "1px solid #ced4da",
						borderRadius: ".25rem",
						borderLeft: "none",
						marginLeft: "-4px",
						padding: '0px',
						backgroundColor: 'transparent'
					}}
				>
					<Button color="default"
						className="bg-transparent btn-sm"
						onClick={showHide}>
						{type === 'text' ?
							<FontAwesomeIcon icon="eye" /> :
							<FontAwesomeIcon icon="eye-slash" />
						}
					</Button>
				</InputGroupText>
			</InputGroup>
		</FormGroup>
	)
}
export default PasswordInput;